import SpinnerBlock from '@components/spinner/SpinnerBlock'

const SpinnerFullPage = () => <SpinnerBlock height="100vh" />
export default SpinnerFullPage